module.exports = {
      id: "fb-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#fb",
      toString: function () {
        return this.url;
      }
    }